import { completionFilterFromPathname } from "#completion-filter-from-pathname";
import { ToolbarPopoverSwitchRow } from "@-/dev.improve.haniverse.components.ui.toolbar.button.popover";
import {
  useBrowseLevelsIncompletePageNavigator,
  useBrowseLevelsPageNavigator,
} from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.levels.navigator";
import { usePathname } from "@-/com.npmjs.expo-router";

/**
 * Levels filter toggle: hide completed levels (the `incomplete` sub-route) or show every level
 * (`all`). Keeps the existing sub-routes so filtered lists retain their scroll positions.
 */
// eslint-disable-next-line filename-export/match-named-export -- the pathname→filter helper moved to its own file (react-refresh only-export-components); this component-only file keeps the descriptive `completion-filter` name, but `stripextra` reduces `LevelsTopbarCompletionFilter` past it.
export function LevelsTopbarCompletionFilter({ disabled = false }: { disabled?: boolean }) {
  const allNavigator = useBrowseLevelsPageNavigator();
  const incompleteNavigator = useBrowseLevelsIncompletePageNavigator();
  const replaceAll = allNavigator.replace.mutate;
  const replaceIncomplete = incompleteNavigator.replace.mutate;
  const hideCompleted = completionFilterFromPathname(usePathname()) === "incomplete";

  return (
    <ToolbarPopoverSwitchRow
      checked={hideCompleted}
      disabled={disabled}
      label="Hide Completed Levels"
      onCheckedChange={(checked) => {
        if (checked) {
          replaceIncomplete();
        } else {
          replaceAll();
        }
      }}
      testID="levels-hide-completed"
    />
  );
}
